import { themes } from '../styles/themes';
import once from 'lodash.once';

export const opacity = (sinVotos, ambNoSeleccionado, esMuniOComu) => {
  return sinVotos && ambNoSeleccionado
    ? 0.8
    : ambNoSeleccionado && esMuniOComu
    ? 0.5
    : esMuniOComu
    ? 1
    : 0.9;
};

export const borderColor = (sinVotos, ambNoSeleccionado, esMuniOComu) => {
  return themes.color.mapBorder;
};

export const borderWidth = (ambNoSeleccionado, esMuniOComu) => {
  return esMuniOComu && ambNoSeleccionado ? 0.5 : !ambNoSeleccionado ? 2 : 1;
};

export const shadowColor = (sinVotos, ambSeleccionado) => {
  return ambSeleccionado && sinVotos
    ? 'rgba(0,0,0,0.4)'
    : ambSeleccionado
    ? 'rgba(0,0,0,0.7)'
    : 'rgba(0, 0, 0, 0.3)';
};

export const emphasis = (sinVotos, color, hayEmpate) => {
  const emphasis = {
    borderWidth: 2,
    shadowColor: !sinVotos
      ? hayEmpate
        ? themes.color.coloresEmpate[0]
        : color
      : themes.color.mapBorder,
    borderColor: themes.color.mapBorderHover,
    shadowBlur: 25,
  };
  emphasis.areaColor = hayEmpate
    ? hayEmpate
    : sinVotos
    ? themes.color.sinInfo
    : color;
  return emphasis;
};

export const color = (sinVotos, hayEmpate, color) => {
  if (hayEmpate) {
    return themes.color.coloresEmpate[0];
    const img = strippedCanvas(
      Array.isArray(color) ? color : themes.color.coloresEmpate,
      {
        canvasWidth: 1000,
        canvasHeight: 1000,
        width: 1,
      }
    );
    if (!img) return themes.color.coloresEmpate[0];
    return {
      image: img,
      repeat: 'repeat',
    };
  } else {
    return sinVotos ? themes.color.sinInfo : color;
  }
};

export const strippedCanvas = once((colorsArray, options = {}) => {
  // return null;
  const patternCanvas = document.createElement('canvas');
  const {
    width = 8,
    height = 1,
    repeat = 1,
    canvasWidth = 10000,
    canvasHeight = 10000,
  } = options;
  patternCanvas.width = width * colorsArray.length;
  patternCanvas.height = height;
  for (let i = 0; i < repeat; i++) {
    colorsArray.forEach((color, k) => {
      const ctx = patternCanvas.getContext('2d');
      if (ctx) {
        ctx.fillStyle = color;
        ctx.fillRect(width * (k + i * colorsArray.length), 0, width, height);
      }
    });
  }

  const canvas = document.createElement('canvas');
  canvas.width = canvasWidth;
  canvas.height = canvasHeight;
  const ctx = canvas?.getContext('2d');
  if (ctx) {
    const pattern = ctx.createPattern(patternCanvas, 'repeat');
    ctx.fillStyle = pattern;
    ctx.fillRect(0, 0, canvasWidth, canvasHeight);
  }

  return canvas;
});
